module.exports = "- The first time you see JSX is like the first time you see an ugly baby.\n\n- Seeing JSX for the first time tonight. I think I have fallen in love at first sight."


//////////////////
// WEBPACK FOOTER
// ./src/slides/07_jsx/notes_3.md
// module id = 1501
// module chunks = 0